import { LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { tryParseInt } from 'src/util/values';

export function getPageQueryParams(
  page: PageEvent,
  defaultPageSize?: number,
): { page?: number; pageSize?: number } {
  const pageNumber = page.pageIndex + 1;
  return {
    page: pageNumber > 1 ? pageNumber : undefined,
    pageSize: pageNumber === 1 && page.pageSize === defaultPageSize ? undefined : page.pageSize,
  };
}

export function getPageIndex(route: ActivatedRoute): Observable<number> {
  return route.queryParams.pipe(
    map((p) => {
      const page = tryParseInt(p.page);
      if (page != null) {
        return page - 1;
      }
      return 0;
    }),
  );
}

export function getPageSize(
  route: ActivatedRoute,
  defaultPageSize?: number,
): Observable<number | undefined> {
  return route.queryParams.pipe(
    map((p) => {
      const pageSize = tryParseInt(p.pageSize);
      return pageSize != null ? pageSize : defaultPageSize;
    }),
    // startWith(defaultPageSize)
  );
}

export function getSkipTakePageEvent(page: PageEvent): {
  skip: number;
  take: number;
} {
  return {
    skip: page.pageIndex * page.pageSize,
    take: page.pageSize,
  };
}

export interface SkipTake {
  skip: number;
  take: number;
}

export function tryGetSkipTakeOrDefault(
  { page: maybePage, pageSize: maybePageSize }: { page?: any; pageSize?: any },
  defaultPageSize: number,
): SkipTake {
  maybePage = tryParseInt(maybePage);
  const page = maybePage != null && maybePage > 0 ? maybePage : 1;
  maybePageSize = tryParseInt(maybePageSize);
  const pageSize = maybePageSize != null && maybePageSize > 0 ? maybePageSize : defaultPageSize;

  return getSkipTake({ page, pageSize });
}

export function getSkipTake({ page, pageSize }: { page: number; pageSize: number }): SkipTake {
  const pageIndex = page - 1;
  const skip = pageIndex * pageSize;
  const take = pageSize;
  return {
    skip,
    take,
  };
}
